export default (params) => ({
  trigger: {
    name: 'product_collection.open_collection',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_list_id: {
        type: 'integer',
      },
      item_list_name: {
        type: 'string',
      },
      number_of_items: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'multi_discriminant_selector',
          'drop_down_selector',
          'drop_down_panel',
        ],
      },
    },
    event: {
      name: 'select_item_list',
    },
  },
});
